import { Link, Route, Routes, useLocation } from 'react-router-dom';
import T from '@wojtekmaj/react-t';

import { FormWrapper, HeaderAndFormWrapper, Main, PageWrapper } from './index.styles';

import Footer from '../../footer';
import Header from '../../header';
import Heading from '../../heading';
import LoginEmail from './email';
import LoginMain from './main';
import LoginTwoStepEmail from './two_step_email';

export default function LoginPage() {
  const location = useLocation();

  return (
    <PageWrapper>
      <HeaderAndFormWrapper>
        <Header />
        <FormWrapper>
          <Main>
            <Heading align="center">Login</Heading>
            <Routes>
              <Route element={<LoginMain />} path="" />
              <Route element={<LoginEmail />} path="email" />
              <Route element={<LoginTwoStepEmail />} path="two_step_email/*" />
            </Routes>
            <p>
              <T>Don’t have an account yet?</T>{' '}
              <Link state={location.state} to="/register">
                <T>Register</T>
              </Link>
              .
            </p>
          </Main>
        </FormWrapper>
      </HeaderAndFormWrapper>
      <Footer />
    </PageWrapper>
  );
}
